import React from "react";
import { range } from "lodash-es";

import { Skeleton } from "shared/components";

import {
  StyledTable,
  StyledHeaderRow,
  StyledCell,
  StyledRow,
  TableOverflowWrapper,
  TableScrollWrapper,
} from "../styles";
import { ITheme } from "shared/types";

interface TableSkeletonProps {
  nbColumns?: number;
  nbRows?: number;
  theme?: ITheme;
}

export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  nbColumns = 5,
  nbRows = 3,
  theme,
}) => {
  return (
    <TableOverflowWrapper>
      <TableScrollWrapper>
        <StyledTable>
          <thead>
            <StyledHeaderRow>
              {range(nbColumns).map((item, index) => (
                <StyledCell key={index} theme={theme}>
                  <Skeleton />
                </StyledCell>
              ))}
            </StyledHeaderRow>
          </thead>
          <tbody>
            {range(nbRows).map((row, i) => {
              const stripedRow = i % 2 === 0;
              return (
                <React.Fragment key={i}>
                  <StyledRow stripedRow={stripedRow}>
                    {range(nbColumns).map((item, index) => {
                      return (
                        <StyledCell key={index} stripedRow={stripedRow} theme={theme}>
                          <Skeleton />
                        </StyledCell>
                      );
                    })}
                  </StyledRow>
                </React.Fragment>
              );
            })}
          </tbody>
        </StyledTable>
      </TableScrollWrapper>
    </TableOverflowWrapper>
  );
};
